import { Component, Input, OnInit } from '@angular/core';

import { ApiError, BaseFormList, MessageService } from '../../../core';

import { UsuarioLinha } from './usuario-linha';
import { ItemLinha, ItemLinhaCrudHttpService } from '../../item-linha';

@Component({
    selector: 'sgt-usuario-linha',
    templateUrl: './usuario-linha.component.html',
    styleUrls: ['./usuario-linha.component.less']
})
export class UsuarioLinhaComponent implements BaseFormList<UsuarioLinha>, OnInit {
    @Input() entities: UsuarioLinha[];
    linhas: ItemLinha[];

    constructor(private messageService: MessageService,
                private itemLinhaCrudHttpService: ItemLinhaCrudHttpService) { }

    ngOnInit() {
        this.searchLinhas();
    }

    /** Pesquisa as Linhas cadastradas */
    private searchLinhas() {
        this.linhas = [];
        this.itemLinhaCrudHttpService.search()
            .subscribe(
                entities => this.linhas = entities,
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar as linhas', error)
            );
    }

    /** Ao alterar a Linha */
    onChangeLinha(entity: UsuarioLinha, idItemLinha: number) {
        entity.idItemLinha = idItemLinha;
        if (idItemLinha) {
            entity.itemLinha = this.linhas.find(linhaFilter => linhaFilter.id === idItemLinha);
        } else {
            entity.itemLinha = null;
        }
    }

    insert() {
        const entity = new UsuarioLinha();
        this.entities.push(entity);
    }

    delete(index: number) {
        const entity = this.entities[index];
        this.messageService.confirm(`Deseja realmente excluir a Linha ${(entity && entity.itemLinha) ? entity.itemLinha.nome : ''} do usuário?`).then(result => {
            if (result) {
                this.entities.splice(index, 1);
            }
        });
    }

    /** Verifica se as linhas do Usuario estão válidas */
    isValid(): boolean {
        for (let i = 0; i < this.entities.length; i++) {
            const entity = this.entities[i];


            const count = this.entities.filter(entityFilter => entityFilter.idItemLinha && entityFilter.idItemLinha === entity.idItemLinha).length;
            const nomeLinha = (entity && entity.itemLinha) ? entity.itemLinha.nome : ''
            if (count > 1) {
                this.messageService.info(`A linha ${nomeLinha} já está adicionada. Remova ou altere a linha duplicada`, 'Não é possível adicionar duas linhas iguais');
                return false;
            }
        }

        return true;
    }

    /** Resolve as linhas do Usuario */
    resolve() {
        for (let i = this.entities.length; i--; ) {
            const entity = this.entities[i];
            if (!entity.idItemLinha) {
                this.entities.splice(i, 1);
            }
        }
    }

    /** Adiciona todas as linhas cadastradas ao Usuario */
    adicionarTodasLinhas() {
        if (!this.linhas) {
            return;
        }

        for (let i = 0; i < this.linhas.length; i++) {
            const Linha = this.linhas[i];

            // Somente adiciona quando a linha ainda não estiver adicionada
            const index = this.entities.findIndex(linhaFilter => linhaFilter.idItemLinha === Linha.id);
            if (index === -1) {
                const entity = new UsuarioLinha();
                entity.idItemLinha = Linha.id;
                entity.itemLinha = Linha;
                this.entities.push(entity);
            }
        }
    }
}
